import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function TargetAudience() {
  return <section className="bg-violet text-white py-12" data-id="element-268">
      <div className="max-w-md mx-auto px-4" data-id="element-269">
        <h2 className="text-2xl font-bold text-center mb-8" data-id="element-270">
          ¿Este sistema es para vos?
        </h2>

        <div className="flex flex-col gap-4" data-id="element-271">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-272">
            <h3 className="text-lg font-bold mb-2 flex items-center gap-2" data-id="element-273">
              <span data-id="element-274">🎓</span> Docentes recién designados
            </h3>
            <p className="text-sm text-white/90 mb-4 leading-relaxed" data-id="element-275">
              Te nombraron en la escuela pero nadie te dio un repertorio armado.
              Con Flauta Master Class tenés partituras completas por ocasión,
              listas para dar clase desde el primer día.
            </p>
            <ul className="text-sm space-y-2" data-id="element-276">
              <li className="flex items-start gap-2" data-id="element-277">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-278" />
                <span data-id="element-279">Repertorio organizado por tema y nivel</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-280">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-281" />
                <span data-id="element-282">Digitación simplificada incluida</span>
              </li>
            </ul>
          </div>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-283">
            <h3 className="text-lg font-bold mb-2 flex items-center gap-2" data-id="element-284">
              <span data-id="element-285">📅</span> Docentes titulares con curso a cargo
            </h3>
            <p className="text-sm text-white/90 mb-4 leading-relaxed" data-id="element-286">
              Repetís siempre las mismas canciones porque no tenés tiempo de
              buscar variantes. Con el banco de +200 partituras, cada trimestre
              se siente distinto.
            </p>
            <ul className="text-sm space-y-2" data-id="element-287">
              <li className="flex items-start gap-2" data-id="element-288">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-289" />
                <span data-id="element-290">Repertorio para todo el ciclo lectivo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-291">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-292" />
                <span data-id="element-293">Planificador anual incluido</span>
              </li>
            </ul>
          </div>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-294">
            <h3 className="text-lg font-bold mb-2 flex items-center gap-2" data-id="element-295">
              <span data-id="element-296">🎼</span> Docentes que arman actos y ensambles
            </h3>
            <p className="text-sm text-white/90 mb-4 leading-relaxed" data-id="element-297">
              Querés que el acto escolar suene profesional, no como siempre. El
              Plan PRO te da arreglos a 2 voces y pistas de acompañamiento para
              que el curso se luzca.
            </p>
            <ul className="text-sm space-y-2" data-id="element-298">
              <li className="flex items-start gap-2" data-id="element-299">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-300" />
                <span data-id="element-301">Arreglos a 2 voces para ensamble</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-302">
                <CheckCircle2 className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-303" />
                <span data-id="element-304">Pistas de acompañamiento (backing tracks)</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}